import styled from "styled-components";
import { typography } from "@streeteasy/design-system";

import { errorIcon } from "../../seller-services/assets/error-icon";

const { P } = typography;

export const ErrorContent = styled.div`
  text-align: center;
`;

export const ErrorText = styled(P)`
  margin-top: 15px;
`;

export const ErrorIcon = styled.img.attrs({
  "aria-hidden": true,
  alt: "Error",
  src: errorIcon
})`
  min-height: 25px;
`;
